import { createFileRoute } from '@tanstack/react-router';
import { AdminDashboard } from '../../components/admin/admin-dashboard';

export const Route = createFileRoute('/admin/dashboard')({
  component: AdminDashboard,
});
